import React from 'react';
export const Lock = () => (
  <svg width="201px" height="154px" viewBox="0 0 201 154" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-770.000000, -990.000000)">
        <g transform="translate(770.000000, 990.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M66.4849,81.8442 L66.4849,83.8442"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M66.4849,87.8442 L66.4849,89.8442"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M70.4849,85.8442 L68.4849,85.8442"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M64.4849,85.8442 L62.4849,85.8442"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M141.7681,106.7055 L141.7681,108.7055"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M141.7681,112.7055 L141.7681,114.7055"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M145.7681,110.7055 L143.7681,110.7055"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M139.7681,110.7055 L137.7681,110.7055"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M60.2149,97.2358 C60.2149,98.0738 59.5359,98.7538 58.6969,98.7538 C57.8589,98.7538 57.1789,98.0738 57.1789,97.2358 C57.1789,96.3968 57.8589,95.7168 58.6969,95.7168 C59.5359,95.7168 60.2149,96.3968 60.2149,97.2358"
            fill="#F5C400"
          />
          <path
            d="M137.7681,95.6801 C137.7681,96.5181 137.0881,97.1981 136.2501,97.1981 C135.4121,97.1981 134.7321,96.5181 134.7321,95.6801 C134.7321,94.8411 135.4121,94.1621 136.2501,94.1621 C137.0881,94.1621 137.7681,94.8411 137.7681,95.6801"
            fill="#AA81F7"
          />
          <path
            d="M86.9302,100.6527 C85.5652,100.6527 84.4582,99.5457 84.4582,98.1797 L84.4582,73.5467 C84.4582,64.2557 92.0162,56.6967 101.3062,56.6967 C110.5962,56.6967 118.1542,64.2557 118.1542,73.5467 L118.1542,77.1647 C118.1542,78.5297 117.0472,79.6367 115.6812,79.6367 C114.3162,79.6367 113.2092,78.5297 113.2092,77.1647 L113.2092,73.5467 C113.2092,66.9827 107.8692,61.6417 101.3062,61.6417 C94.7422,61.6417 89.4032,66.9827 89.4032,73.5467 L89.4032,98.1797 C89.4032,99.5457 88.2952,100.6527 86.9302,100.6527"
            fill="#FFFFFF"
          />
          <path
            d="M110.1168,65.5492 C107.9378,63.1512 104.7948,61.6422 101.3058,61.6422 C94.7418,61.6422 89.4028,66.9832 89.4028,73.5462 L89.4028,98.1802 C89.4028,99.5452 88.2958,100.6532 86.9298,100.6532 C85.5648,100.6532 84.4578,99.5452 84.4578,98.1802 L84.4578,73.5462 C84.4578,68.4422 86.7388,63.8612 90.3348,60.7692"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M94.3336,58.2084 C96.4596,57.2374 98.8206,56.6964 101.3066,56.6964 C110.5956,56.6964 118.1546,64.2554 118.1546,73.5464 L118.1546,77.1644 C118.1546,78.5294 117.0476,79.6374 115.6816,79.6374 C114.3166,79.6374 113.2096,78.5294 113.2096,77.1644 L113.2096,73.5464 C113.2096,71.9494 112.8936,70.4254 112.3206,69.0324"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M118.9161,86.2621 L90.4301,86.2621 C87.8131,86.2621 85.6911,88.3831 85.6911,91.0001 L85.6911,113.9811 C85.6911,116.5981 87.8131,118.7191 90.4301,118.7191 L118.9161,118.7191 C121.5331,118.7191 123.6541,116.5981 123.6541,113.9811 L123.6541,91.0001 C123.6541,88.3831 121.5331,86.2621 118.9161,86.2621"
            fill="#F3F4F6"
          />
          <path
            d="M117.6563,82.9135 L85.5423,82.9135 C83.9273,82.9135 82.6183,84.2235 82.6183,85.8385 L82.6183,112.4465 C82.6183,114.0615 83.9273,115.3715 85.5423,115.3715 L117.6563,115.3715 C119.2713,115.3715 120.5803,114.0615 120.5803,112.4465 L120.5803,85.8385 C120.5803,84.2235 119.2713,82.9135 117.6563,82.9135"
            fill="#FFFFFF"
          />
          <path
            d="M115.4634,115.3715 L118.1084,115.3715 C119.4734,115.3715 120.5804,114.2645 120.5804,112.8985 L120.5804,85.3865 C120.5804,84.0205 119.4734,82.9135 118.1084,82.9135 L85.0904,82.9135 C83.7254,82.9135 82.6184,84.0205 82.6184,85.3865 L82.6184,90.0345"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M82.6182,95.7631 L82.6182,112.8991 C82.6182,114.2641 83.7252,115.3711 85.0902,115.3711 L112.6862,115.3711"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <g transform="translate(97.000000, 90.710000)">
            <path
              d="M7.9156,12.347 L9.0686,15.022 C9.2656,15.481 8.9296,15.992 8.4306,15.992 L0.7676,15.992 C0.2686,15.992 -0.0674,15.481 0.1306,15.022 L3.1036,8.123 C1.7606,7.544 0.8196,6.208 0.8196,4.653 C0.8196,2.566 2.5116,0.873 4.5996,0.873 C6.6866,0.873 8.3786,2.566 8.3786,4.653 C8.3786,6.208 7.4386,7.544 6.0946,8.123 L6.8786,9.943"
              fill="#AA81F7"
            />
            <path
              d="M7.9156,12.347 L9.0686,15.022 C9.2656,15.481 8.9296,15.992 8.4306,15.992 L0.7676,15.992 C0.2686,15.992 -0.0674,15.481 0.1306,15.022 L3.1036,8.123 C1.7606,7.544 0.8196,6.208 0.8196,4.653 C0.8196,2.566 2.5116,0.873 4.5996,0.873 C6.6866,0.873 8.3786,2.566 8.3786,4.653 C8.3786,6.208 7.4386,7.544 6.0946,8.123 L6.8786,9.943"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M98.5421,112.2006 L100.5001,112.2006"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.6734,101.7221 L85.6734,111.5341 C85.6734,111.9021 85.9714,112.2011 86.3404,112.2011 L96.5834,112.2011"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.6612,153.183 L163.4062,153.183"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.5753,153.183 L43.8193,153.183"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.8189,153.183 L26.7829,153.183"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
